import { useSelector } from "react-redux";

export default function StepperControl({ handleClick, currentStep, steps }) {
  // redux states for first page
  const firstName = useSelector((state) => state.freelancer.firstName);
  const lastName = useSelector((state) => state.freelancer.lastName);
  const phoneNumber = useSelector((state) => state.freelancer.phoneNumber);
  const email = useSelector((state) => state.freelancer.email);
  const dob = useSelector((state) => state.freelancer.dob);
  const country = useSelector((state) => state.freelancer.country);
  const city = useSelector((state) => state.freelancer.city);
  const citizenship = useSelector((state) => state.freelancer.citizenship);
  // redux states for second page
  const jobLookFor = useSelector((state) => state.freelancer.jobLookFor);
  const proffExp = useSelector((state) => state.freelancer.proffExp);
  const pJobInt = useSelector((state) => state.freelancer.pJobInt);
  const pJobExp = useSelector((state) => state.freelancer.pJobExp);
  const skills = useSelector((state) => state.freelancer.skills);
  const pHourRate = useSelector((state) => state.freelancer.pHourRate);
  const pMonthlySalary = useSelector(
    (state) => state.freelancer.pMonthlySalary,
  );
  const freelanceEmailError = useSelector(
    (state) => state.freelancer.freelanceEmailError,
  );
  const freelancePhoneError = useSelector(
    (state) => state.freelancer.freelancePhoneError,
  );
  const freelancefirstnameError = useSelector(
    (state) => state.freelancer.freelancefirstnameError,
  );
  const freelancelastnameError = useSelector(
    (state) => state.freelancer.freelancelastnameError,
  );
  const freelancecountryError = useSelector(
    (state) => state.freelancer.freelancecountryError,
  );
  const freelancecityError = useSelector(
    (state) => state.freelancer.freelancecityError,
  );
  const freelancecitizenshipError = useSelector(
    (state) => state.freelancer.freelancecitizenshipError,
  );
  const freelancebirthdateError = useSelector(
    (state) => state.freelancer.freelancebirthdateError,
  );
  const freelanceexperienceError = useSelector(
    (state) => state.freelancer.freelanceexperienceError,
  );
  const freelancejobtypeError = useSelector(
    (state) => state.freelancer.freelancejobtypeError,
  );
  const freelanceprimaryjobinterestError = useSelector(
    (state) => state.freelancer.freelanceprimaryjobinterestError,
  );
  const freelanceexperienceyearError = useSelector(
    (state) => state.freelancer.freelanceexperienceyearError,
  );
  const freelancehourlyrateError = useSelector(
    (state) => state.freelancer.freelancehourlyrateError,
  );
  const freelancelinkdinurlError = useSelector(
    (state) => state.freelancer.freelancelinkdinurlError,
  );
  const freelancegithuburlError = useSelector(
    (state) => state.freelancer.freelancegithuburlError,
  );
  const freelancemonthlysalaryError = useSelector(
    (state) => state.freelancer.freelancemonthlysalaryError,
  );

  const isFirstPageValid =
    firstName &&
    lastName &&
    phoneNumber &&
    email &&
    dob &&
    country &&
    city &&
    citizenship &&
    !freelanceEmailError &&
    !freelancePhoneError &&
    !freelancefirstnameError &&
    !freelancelastnameError &&
    !freelancecountryError &&
    !freelancecityError &&
    !freelancecitizenshipError &&
    !freelancebirthdateError;

  const isSecondPageValid =
    jobLookFor &&
    proffExp &&
    pJobInt &&
    pJobExp &&
    skills?.length !== 0 &&
    pHourRate &&
    pMonthlySalary &&
    citizenship &&
    !freelanceexperienceError &&
    !freelancejobtypeError &&
    !freelanceprimaryjobinterestError &&
    !freelanceexperienceyearError &&
    !freelancehourlyrateError &&
    !freelancemonthlysalaryError &&
    !freelancelinkdinurlError &&
    !freelancegithuburlError;

  const isButtonDisabled =
    !(currentStep === 1 && isFirstPageValid) &&
    !(currentStep === 2 && isSecondPageValid);

  return (
    <div className="container mt-4 mb-8 flex justify-around">
      {/* Conditionally render the "Next" button */}
      {currentStep < 3 && (
        <button
          onClick={() => handleClick("next")}
          className={`rounded-lg py-2 px-4 font-semibold uppercase text-white transition duration-200 ease-in-out hover:bg-slate-700 hover:text-white ${
            isButtonDisabled
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-500 cursor-pointer"
          }`}
          disabled={isButtonDisabled}>
          Next
        </button>
      )}
    </div>
  );
}
